export default "__VITE_ASSET__pB6ni_G0__"